import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  BhojanCategory,
  BhojanCategoryPayload,
} from "@project/types/bhojan";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/bhojan-categories`;
const SILENT: RequestConfig = { showNotification: false };

class BhojanCategoryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<BhojanCategory>> =>
    fetchListPage<BhojanCategory>(`${BASE}/`, query);

  get = async (id: number): Promise<BhojanCategory | undefined> => {
    const data = await get<ApiItemResponse<BhojanCategory> | BhojanCategory>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: BhojanCategoryPayload): Promise<BhojanCategory> => {
    const data = await post<
      ApiItemResponse<BhojanCategory> | BhojanCategory,
      BhojanCategoryPayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create bhojan category.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<BhojanCategoryPayload>
  ): Promise<BhojanCategory | undefined> => {
    const data = await patch<
      ApiItemResponse<BhojanCategory> | BhojanCategory,
      Partial<BhojanCategoryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };

  listLookup = async (search = "") => {
    const result = await this.listPage({
      page: 1,
      page_size: 50,
      search: search || undefined,
      status: "active",
    });
    return result.data.map(item => ({
      value: String(item.id),
      label: item.name,
    }));
  };
}

export const bhojanCategoryService = new BhojanCategoryService();
